import en from './en';

// English remains the fallback baseline; translated keys below override it.
const hi = {
  ...en,
  "언어": "भाषा",
  "로그인": "लॉगिन",
  "로그아웃": "लॉगआउट",
  "비밀번호": "पासवर्ड",
  "서버 오류": "सर्वर त्रुटि",
  "로그인 실패: ": "लॉगिन विफल: ",
  "🔐 어드민 로그인": "🔐 एडमिन लॉगिन",
  "유저 관리": "यूज़र प्रबंधन",
  "테이블 관리": "टेबल प्रबंधन",
  "전광판": "मार्की",
  "자산기록": "एसेट रिकॉर्ड",
  "결제관리": "पेमेंट प्रबंधन",
  "라운지 관리": "लाउंज प्रबंधन",
  "공지 관리": "नोटिस प्रबंधन",
  "광고 관리": "विज्ञापन प्रबंधन",
  "검색": "खोज",
  "검색어를 입력하세요": "खोज शब्द दर्ज करें",
  "새로고침": "रीफ़्रेश",
  "로딩 중...": "लोड हो रहा है...",
  "로딩중...": "लोड हो रहा है...",
  "불러오는 중…": "लोड हो रहा है…",
  "불러오기 실패": "लोड विफल",
  "데이터 없음": "कोई डेटा नहीं",
  "데이터가 없습니다.": "कोई डेटा उपलब्ध नहीं।",
  "표시할 기록이 없습니다.": "दिखाने के लिए कोई रिकॉर्ड नहीं।",
  "생성": "बनाएँ",
  "생성 중...": "बन रहा है...",
  "생성 중…": "बन रहा है…",
  "생성 실패: ": "बनाना विफल: ",
  "생성 에러:": "बनाने में त्रुटि:",
  "수정": "संपादित करें",
  "저장": "सेव",
  "저장 중...": "सेव हो रहा है...",
  "저장 실패": "सेव विफल",
  "삭제": "हटाएँ",
  "삭제 실패": "हटाना विफल",
  "삭제됨": "हटाया गया",
  "취소": "रद्द करें",
  "닫기": "बंद करें",
  "확인": "पुष्टि",
  "복사": "कॉपी",
  "상태": "स्थिति",
  "상세": "विवरण",
  "관리": "प्रबंधित करें",
  "관리 상태": "एडमिन स्थिति",
  "노출": "दिखाएँ",
  "노출중": "दिख रहा है",
  "비활성": "निष्क्रिय",
  "활성": "सक्रिय",
  "게시": "प्रकाशित",
  "게시 중": "प्रकाशित हो रहा है",
  "게시 상태": "प्रकाशन स्थिति",
  "만료": "समाप्त",
  "만료일:": "समाप्ति:",
  "게시일:": "प्रकाशित:",
  "예약": "आरक्षित",
  "예약 없음": "कोई आरक्षण नहीं",
  "상시": "हमेशा",
  "미리보기": "पूर्वावलोकन",
  "그룹 생성": "ग्रुप बनाएँ",
  "그룹 이름": "ग्रुप नाम",
  "그룹명": "ग्रुप नाम",
  "그룹 노출(DisplaySet)": "ग्रुप एक्सपोज़र (DisplaySet)",
  "테이블 그룹": "टेबल ग्रुप",
  "테이블 생성": "टेबल बनाएँ",
  "테이블 목록": "टेबल सूची",
  "테이블 미션": "टेबल मिशन",
  "테이블 미션 설정": "टेबल मिशन सेटिंग",
  "Small Blind": "Small Blind",
  "Big Blind": "Big Blind",
  "Rake % (수수료율)": "Rake % (फ़ीस दर)",
  "라운지 포인트 %": "लाउंज पॉइंट %",
  "라운지 포인트 % (0~100)": "लाउंज पॉइंट % (0–100)",
  "라운지 포인트 지급률": "लाउंज पॉइंट दर",
  "현재 라운지 포인트 %": "मौजूदा लाउंज पॉइंट %",
  "startAt (시작)": "startAt (शुरू)",
  "endAt (종료, 선택)": "endAt (समाप्त, वैकल्पिक)",
  "시작": "शुरू",
  "종료": "समाप्त",
  "시작(로컬)": "शुरू (लोकल)",
  "종료(로컬)": "समाप्त (लोकल)",
  "시작일": "शुरू तारीख",
  "기간": "अवधि",
  "무한(30일 갱신)": "अनलिमिटेड (30 दिन रिन्यू)",
  "24시간 반복": "हर 24 घंटे दोहराएँ",
  "공지 작성/관리": "नोटिस बनाएँ/प्रबंधित करें",
  "공지 제목": "नोटिस शीर्षक",
  "공지 본문": "नोटिस बॉडी",
  "공지 수정": "नोटिस संपादित करें",
  "새 공지 작성": "नया नोटिस बनाएँ",
  "광고 이미지 등록/관리": "विज्ञापन इमेज 등록/प्रबंधन",
  "광고 수정": "विज्ञापन संपादित करें",
  "새 광고 등록": "नया विज्ञापन 등록",
  "광고 이미지": "विज्ञापन इमेज",
  "라운지 글": "लाउंज पोस्ट",
  "라운지 글 목록": "लाउंज पोस्ट सूची",
  "라운지 아이템": "लाउंज आइटम",
  "라운지 업로드": "लाउंज अपलोड",
  "라운지포인트": "लाउंज पॉइंट",
  "결제 영역": "पेमेंट क्षेत्र",
  "결제 옵션": "पेमेंट विकल्प",
  "결제 옵션 추가": "पेमेंट विकल्प जोड़ें",
  "결제 완료": "पेमेंट पूरा",
  "결제 항목": "पेमेंट आइटम",
  "금액": "राशि",
  "수량": "मात्रा",
  "미결제": "अनपेड",
  "자산": "एसेट",
  "레이크백": "Rakeback",
  "일반 자산": "सामान्य एसेट",
  "라운지포인트": "लाउंज पॉइंट",
  "관리자 자산 표시 영역": "एडमिन एसेट सारांश क्षेत्र",
  "나의 지갑 주소": "मेरा वॉलेट पता",
  "보내는 지갑": "भेजने वाला वॉलेट",
  "받는 지갑": "प्राप्त वॉलेट",
  "에이전트": "एजेंट",
  "에이전트로 생성": "एजेंट के रूप में बनाएँ",
  "하위 계정 생성": "सब अकाउंट बनाएँ",
  "하위 생성": "चाइल्ड बनाएँ",
  "하위 {id}": "चाइल्ड {id}",
  "소속 유저": "असाइन किए गए यूज़र",
  "소속유저": "असाइन किए गए यूज़र",
  "상위 에이전트:": "पैरेंट एजेंट:",
  "수수료": "फ़ीस",
  "수수료 수정": "फ़ीस संपादित करें",
  "수수료 수정 실패": "फ़ीस संपादन विफल",
  "분배 비율": "वितरण दर",
  "분배 비율(상대 %)": "वितरण दर (सापेक्ष %)",
  "Country 필터": "देश फ़िल्टर",
  "Device 필터": "डिवाइस फ़िल्टर",
  "동아시아": "पूर्वी एशिया",
  "동남아": "दक्षिण-पूर्व एशिया",
  "유럽": "यूरोप",
  "북미": "उत्तर अमेरिका",
  "남미": "दक्षिण अमेरिका",
  "아프리카": "अफ़्रीका",
  "글로벌": "ग्लोबल",
  "제목": "शीर्षक",
  "본문": "बॉडी",
  "내용(message)": "सामग्री (message)",
  "이미지": "इमेज",
  "이미지 URL": "इमेज URL",
  "업로드": "अपलोड",
  "업로드중...": "अपलोड हो रहा है...",
  "링크 열기": "लिंक खोलें",
  "링크:": "लिंक:",
  "인포카드": "इन्फो कार्ड",
  "하이라이트 포인트": "हाइलाइट पॉइंट",
  "하이라이트 메세지": "हाइलाइट संदेश",
  "프리셋 수정": "प्रीसेट संपादित करें",
  "배경 색상": "बैकग्राउंड रंग",
  "배경 이미지 URL": "बैकग्राउंड इमेज URL",
  "배경 타입": "बैकग्राउंड प्रकार",
  "폰트스타일": "फ़ॉन्ट स्टाइल",
  "굵기": "वज़न",
  "색상": "रंग",
  "표시명": "डिस्प्ले नाम",
  "페이지": "पेज",
  "페이지 크기": "पेज साइज़",
  "다음": "अगला",
  "이전": "पिछला",
  "위로": "ऊपर",
  "아래로": "नीचे",
  "펼치기": "खोलें",
  "개": "आइटम",
  "건": "रिकॉर्ड",
  "명": "यूज़र",
  "⚠️ 권한이 없습니다": "⚠️ अनुमति नहीं है",
  "이 페이지에 접근할 수 있는 권한이 없습니다.": "आपको इस पेज तक पहुँचने की अनुमति नहीं है।",
};

export default hi;
